"use client";

import type { FC, Ref } from "react";
import {
  ViewingTipsListCard,
  type ViewingTipsListCardProps,
  type ViewingTipCategory,
} from "@huub-web/shared";

export interface ViewingTipsTemplateProps {
  title: string;
  category: ViewingTipCategory;
  tips: ViewingTipsListCardProps["tips"];
  icon?: ViewingTipsListCardProps["icon"];
  description?: string;
}

/**
 * @deprecated
 */
export const ViewingTipsTemplate: FC<
  ViewingTipsTemplateProps & { ref?: Ref<HTMLDivElement> }
> = ({ tips, title, icon, description, category, ref }) => (
  <ViewingTipsListCard
    ref={ref}
    title={title}
    category={category}
    tips={tips}
    icon={icon}
    description={description}
  />
);
